// Markdown helpers — parse a page's content into blocks (page title, sections,
// items) and serialize blocks back to a markdown string.

// Matches inline attachment references: - 📎 [filename](attachment:uuid)
const ATTACHMENT_RE = /^📎\s*\[([^\]]+)\]\(attachment:([a-f0-9-]+)\)$/;

export function parseAttachmentRef(text) {
  const m = (text || "").trim().match(ATTACHMENT_RE);
  if (!m) return null;
  return { filename: m[1], attachmentId: m[2] };
}

export function parseSections(content) {
  const text = (content || "").replace(/\r\n/g, "\n");
  const lines = text.split("\n");
  const sections = [];
  let pre = []; // lines before the first ## heading
  let current = null;

  const flushItemLine = (line) => {
    if (!current) return false;
    const trimmed = line.replace(/^\s*[-*]\s+/, "");
    if (line.trim().startsWith("-") || line.trim().startsWith("*")) {
      current.items.push({ id: `i-${current.items.length}-${Math.random().toString(36).slice(2, 7)}`, text: trimmed });
      return true;
    }
    return false;
  };

  for (const raw of lines) {
    const line = raw;
    const stripped = line.trim();
    if (stripped.startsWith("## ")) {
      if (current) sections.push(current);
      current = {
        id: `s-${sections.length}-${Math.random().toString(36).slice(2, 7)}`,
        heading: stripped.slice(3).trim(),
        items: [],
        notes: "",
      };
    } else if (current) {
      if (!flushItemLine(line)) {
        // Treat non-bullet text as appended notes within the section
        if (stripped.length > 0) {
          current.notes += (current.notes ? "\n" : "") + stripped;
        }
      }
    } else {
      if (stripped.length > 0) pre.push(stripped);
    }
  }
  if (current) sections.push(current);
  return { intro: pre.join("\n").trim(), sections };
}

export function serializeSections(intro, sections) {
  const out = [];
  if (intro && intro.trim()) out.push(intro.trim());
  for (const s of sections) {
    out.push(`## ${s.heading || "Untitled section"}`);
    if (s.notes && s.notes.trim()) out.push(s.notes.trim());
    for (const it of s.items) {
      const t = (it.text || "").trim();
      if (t) out.push(`- ${t}`);
    }
  }
  return out.join("\n\n").trim() + "\n";
}
